/**
 * Check if the provided [date] is after current datetime
 *
 * @param date
 * @returns
 */
function isActiveCountdown(date: string): boolean {
  const now = new Date();
  const eventDate = new Date(date);
  return now.getTime() < eventDate.getTime();
}

export default isActiveCountdown;
